import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BadgeCheck, ShieldCheck, Eye, Award, Users, Lock } from 'lucide-react';
import { CtaButton } from './CtaButton';
const pillars = [{
  icon: Award,
  title: 'Trayectoria comprobada',
  desc: 'Brenda Hormaechea, creadora UGC de Argentina con cuenta verificada y +1.500 alumnas y marcas felices.'
}, {
  icon: ShieldCheck,
  title: 'Seguridad garantizada',
  desc: 'Pago 100% seguro, garantía de 7 días y soporte real de una persona, no un bot.'
}, {
  icon: Eye,
  title: 'Transparencia total',
  desc: 'Sabés exactamente qué recibís, cuánto vale y cómo accedés. Sin letra chica.'
}];
export function TrustSection() {
  return <section className="px-6 py-10 flex flex-col items-center text-center max-w-7xl mx-auto relative" data-id="element-422">
      {/* Eyebrow */}
      <div className="inline-flex items-center gap-2 bg-brand-navy text-brand-cream font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] px-5 py-2 rounded-full mb-6 shadow-sm" data-id="element-423">
        <BadgeCheck size={15} strokeWidth={2.5} className="text-[#D98BAF]" data-id="element-424" />
        Confianza & tranquilidad garantizada
      </div>

      <h2 className="font-serif font-bold text-3xl md:text-5xl text-brand-navy mb-4 leading-tight max-w-4xl" data-id="element-425">
        La comunidad de creadoras UGC y colaboraciones con marcas{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark" data-id="element-426">
          más importante del país
        </span>
      </h2>
      <p className="text-brand-navy/70 font-medium text-base md:text-xl max-w-2xl leading-relaxed mb-14" data-id="element-427">
        Un programa creado por{' '}
        <strong className="font-bold" data-id="element-428">Brenda Hormaechea</strong>, de Argentina.
        Detrás de cada video y cada collab paga hay una comunidad real que ya
        confió. 💜
      </p>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-10 max-w-5xl" data-id="element-429">
        {/* Instagram proof */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6
      }} className="relative flex justify-center" data-id="element-430">
          <div className="absolute -inset-4 bg-gradient-to-tr from-brand-lavender/40 via-white to-[#D98BAF]/20 rounded-[3rem] blur-md" data-id="element-431" />

          {/* Phone mockup */}
          <div className="relative z-10 w-full max-w-[300px] rounded-[2.75rem] bg-[#0a0a12] p-2.5 border border-[#2a2a3d] shadow-[0_30px_70px_-25px_rgba(31,31,46,0.6),inset_0_0_0_2px_rgba(255,255,255,0.04)]" data-id="element-432">
            {/* Side buttons */}
            <div className="absolute -left-[3px] top-[110px] w-[3px] h-9 rounded-l bg-[#2a2a3d]" data-id="element-433" />
            <div className="absolute -left-[3px] top-[160px] w-[3px] h-14 rounded-l bg-[#2a2a3d]" data-id="element-434" />
            <div className="absolute -right-[3px] top-[135px] w-[3px] h-16 rounded-r bg-[#2a2a3d]" data-id="element-435" />

            {/* Screen */}
            <div className="relative rounded-[2.1rem] overflow-hidden bg-black" data-id="element-436">
              {/* Dynamic island / notch */}
              <div className="absolute top-2.5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2 bg-black rounded-full h-[22px] w-[88px] shadow-md" data-id="element-437">
                <span className="absolute right-3 w-2 h-2 rounded-full bg-[#1a1a22] ring-1 ring-white/10" data-id="element-438" />
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/dsZSeAw3LE7ggLE48TJE51/insta_bren.jpg" alt="Perfil verificado de Instagram de Brenda Hormaechea con 30.9 mil seguidores" loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-439" />
            </div>
          </div>
          {/* Verified badge */}
          <div className="absolute -top-3 -right-1 md:right-4 z-30 flex items-center gap-1.5 bg-[#1d9bf0] text-white font-black text-xs md:text-sm px-4 py-2 rounded-full shadow-lg" data-id="element-440">
            <BadgeCheck size={16} strokeWidth={2.5} data-id="element-441" />
            Cuenta verificada
          </div>
        </motion.div>

        {/* Scale highlight */}
        <div className="flex flex-col gap-6 text-left" data-id="element-442">
          <div className="rounded-3xl p-[2px] bg-gradient-to-r from-[#D98BAF] via-brand-lavenderDark to-[#D98BAF] shadow-[0_18px_45px_-22px_rgba(217,139,175,0.6)]" data-id="element-443">
            <div className="bg-brand-navy rounded-[1.4rem] p-7 md:p-8 relative overflow-hidden" data-id="element-444">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[#D98BAF]/20 blur-[60px] rounded-full pointer-events-none" data-id="element-445" />
              <div className="relative flex items-center gap-3 mb-2" data-id="element-446">
                <Users size={22} className="text-[#D98BAF]" strokeWidth={2.5} data-id="element-447" />
                <span className="text-brand-cream/70 font-semibold text-sm uppercase tracking-widest" data-id="element-448">
                  Somos una comunidad de
                </span>
              </div>
              <p className="relative text-white font-serif font-black text-5xl md:text-6xl tracking-tight mb-1 drop-shadow-[0_0_18px_rgba(217,139,175,0.3)]" data-id="element-449">
                +30.900
              </p>
              <p className="relative text-brand-cream/80 font-medium text-base md:text-lg mb-6" data-id="element-450">
                creadoras de contenido UGC de todo Argentina 🇦🇷
              </p>

              <div className="relative border-t border-white/10 pt-5 flex items-start gap-3" data-id="element-451">
                <div className="w-11 h-11 shrink-0 rounded-xl bg-gradient-to-b from-[#D98BAF] to-brand-pinkDark flex items-center justify-center shadow-[0_0_18px_rgba(217,139,175,0.4)]" data-id="element-452">
                  <Lock size={20} strokeWidth={2.5} className="text-white" data-id="element-453" />
                </div>
                <p className="text-white/90 font-medium text-sm md:text-base leading-relaxed" data-id="element-454">
                  Y solo{' '}
                  <strong className="text-[#D98BAF] font-black text-lg" data-id="element-455">
                    535
                  </strong>{' '}
                  tienen el privilegio de interactuar a diario en el{' '}
                  <strong className="font-bold" data-id="element-456">
                    grupo privado de WhatsApp
                  </strong>{' '}
                  al que accedés realizando tu compra{' '}
                  <strong className="text-[#D98BAF] font-bold" data-id="element-457">hoy</strong>.
                </p>
              </div>
            </div>
          </div>

          <p className="text-brand-navy/60 font-medium text-sm md:text-base leading-relaxed px-1" data-id="element-458">
            Tu lugar en ese grupo es limitado y se libera únicamente con el
            acceso de hoy. Cuando se completa, se cierra.
          </p>
        </div>
      </div>

      {/* Trust pillars */}
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mb-12" data-id="element-459">
        {pillars.map(({
        icon: Icon,
        title,
        desc
      }, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-white border border-black/5 rounded-3xl p-7 flex flex-col items-center text-center shadow-[0_12px_35px_-20px_rgba(31,31,46,0.4)]" data-id="element-460">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-b from-[#D98BAF] to-brand-pinkDark flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(217,139,175,0.35)]" data-id="element-461">
              <Icon size={26} strokeWidth={2.2} className="text-white" data-id="element-462" />
            </div>
            <h3 className="font-serif font-bold text-brand-navy text-lg md:text-xl mb-2" data-id="element-463">
              {title}
            </h3>
            <p className="text-brand-navy/60 text-sm md:text-base leading-relaxed" data-id="element-464">
              {desc}
            </p>
          </motion.div>)}
      </div>

      <div className="w-full max-w-md md:scale-110 md:my-2" data-id="element-465">
        <CtaButton variant="gold" data-id="element-466">¡QUIERO MI LUGAR EN LA COMUNIDAD!</CtaButton>
      </div>
    </section>;
}